/* src/app/ship/get-shipping-updates-dialog/get-shipping-updates-dialog.component.scss */
.dialog-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem 3.38rem 0.5rem;
  background-color: #E7F2F2;
}
.dialog-header .title {
  font-size: 2.0625rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.5;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1rem 0;
}
@media screen and (min-width: 48rem) {
  .dialog-content {
    padding: 1rem 3rem;
  }
}
.dialog-content p {
  padding: 0 3rem 1rem;
  margin: 0;
  font-size: 1rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content p {
    font-size: 1.25rem;
  }
}
.dialog-content .recipients {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  row-gap: 1rem;
  padding: 0.5rem 0;
  max-height: 32rem;
  overflow-y: auto;
}
.dialog-content .recipients .recipient {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.5rem 3rem;
}
.dialog-content .recipients .recipient:only-child {
  padding: 0 3rem;
}
.dialog-content .recipients .recipient:only-child .recipient-actions .recipient-action.remove {
  display: none;
}
@media screen and (min-width: 48rem) {
  .dialog-content .recipients .recipient:not(:only-child) {
    padding: 1rem 3rem;
  }
}
.dialog-content .recipients .recipient:nth-child(even) {
  background-color: #F8FBFB;
}
.dialog-content .recipients .recipient .recipient-actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: flex-end;
  column-gap: 1rem;
  width: 100%;
}
.dialog-content .recipients .recipient .mat-mdc-form-field {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dialog-content .recipients .recipient .mat-mdc-form-field.form-field--short {
    max-width: calc(50% - 1rem);
  }
}
.dialog-content .person-info-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: flex-end;
  column-gap: 1rem;
  width: 100%;
  padding: 0 3rem;
  margin-top: -0.5rem;
}
.dialog-content .person-info-actions .person-info-action {
  color: #0662BB;
}
.dialog-content .person-info-actions .person-info-action:visited {
  color: #0662BB;
}
.dialog-content .person-info-actions .person-info-action:last-of-type {
  margin-right: -1rem;
}
.dialog-content .field-container {
  padding: 0 3rem;
}
.dialog-content .field-container .mat-mdc-checkbox {
  font-size: 0.875rem;
}
.dialog-content ::ng-deep .readonly {
  cursor: not-allowed;
}
.dialog-content ::ng-deep .readonly .mdc-form-field {
  pointer-events: none;
}
.dialog-content [readonly=true] {
  cursor: not-allowed;
}
.form-actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: center;
  padding: 1rem 3rem;
}
.form-actions .form-action {
  width: 12.5rem;
}
p {
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 1rem 0;
}
:host(.get-shipping-updates-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=get-shipping-updates-dialog.component.css.map */
